export default function ClientInbox() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Inbox Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
